import { http } from '@/api/client/httpClient';
import type { Select2Option } from '@/components/forms/Select2';
import type { NopThresholdDto, NopThresholdSaveDto } from '@/api/types/nopThresholds';

// finkit.tenants.user.riskMonitoring.nopThresholds.nopThreshold -> api/app/nop-threshold
const BASE = '/api/app/nop-threshold';

interface Result<T> {
  value: T;
  text: string;
}
function toOptions(list: Result<string | number>[]): Select2Option[] {
  return (list ?? []).map((r) => ({ value: r.value, label: r.text }));
}
async function options(path: string): Promise<Select2Option[]> {
  const { data } = await http.get<Result<string | number>[]>(`${BASE}/${path}`);
  return toOptions(data);
}

export const nopThresholdApi = {
  async getList(thresholdType: number): Promise<NopThresholdDto[]> {
    const { data } = await http.get<{ items: NopThresholdDto[] }>(BASE, {
      params: { skipCount: 0, maxResultCount: 1000, thresholdType },
    });
    return data.items ?? [];
  },
  getTargetTypes: () => options('target-types'),
  getSymbols: () => options('symbols'),
  getVolumeMatchingSymbols: () => options('volume-matching-symbols'),
  getHedgeStatuses: () => options('hedge-statuses'),
  async save(dto: NopThresholdSaveDto): Promise<void> {
    await http.post(`${BASE}/save`, dto);
  },
  async remove(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  },
  async toggle(id: number, isActive: boolean): Promise<void> {
    await http.post(`${BASE}/${id}/toggle`, null, { params: { isActive } });
  },
};
